import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { CustomAlertComponent } from "./custom-alert.component";

@NgModule({
    imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
    declarations: [CustomAlertComponent],
    exports: [CustomAlertComponent]
})
export class CustomAlertModule {}
